import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import { request } from "@/js/http/http_request";
import { formatPrice, getSymbolCurrency } from "@/js/currency/currencies.js";
import { defaultPagingChoices, paging, creditNote } from "@/js/lists.ts";
import { setFilters, getFilters } from "@/js/filter/filter.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import Paging from "@/components/paging/PagingComponent.vue";
import Index from "@/components/paging/IndexComponent.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "creditNoteListBuyer",
  components: {
    Paging: Paging,
    Index: Index,
    ErrorModal: ErrorModal
  },
  props: {
    searchCriterias: {
      paging: {
        limits: paging.DEFAULT,
        currentPage: 0,
        askedPage: 0
      },
      label: {
        default: ""
      }
    },
    loggedUserData: Object
  },
  data: function data() {
    return {
      isLoading: false,
      user: null,
      items: [],
      headers: [{
        text: "Date",
        value: "creationDate",
        align: "center"
      }, {
        text: "Reference#",
        value: "numberLabel",
        align: "center"
      }, {
        text: "InvoiceOrigin#",
        value: "fromOrderInvoiceNumber",
        align: "center"
      }, {
        text: "Amount",
        value: "totalAmountCurrency",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Remaining",
        value: "remaining.amountCurrency",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "",
        value: "url",
        align: "center"
      }],
      numberOfPages: 0,
      formSearch: {},
      creditNoteCount: null,
      pagingLimitsChoices: defaultPagingChoices,
      creditNote: creditNote,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    hasResult: function hasResult() {
      return !this.isLoading && this.creditNoteCount > 0;
    }
  },
  created: function created() {
    this.formSearch = _objectSpread({}, this.searchCriterias);
    var filters = getFilters();
    if (filters !== null && filters !== void 0 && filters.creditNotesBuyer) {
      this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), filters.creditNotesBuyer);
    }
    this.fetchCreditNotes();
  },
  methods: {
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.numberOfPages) {
        this.formSearch.paging.askedPage = askedPage;
        this.fetchCreditNotes();
        window.scrollTo(0, 0);
      }
    },
    search: function search() {
      var isResetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (isResetPaging) this.resetPaging();
      this.fetchCreditNotes();
    },
    resetPaging: function resetPaging() {
      this.formSearch.paging.askedPage = 0;
    },
    fetchCreditNotes: function fetchCreditNotes() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this = _this2;
              setFilters(function (state) {
                return _objectSpread(_objectSpread({}, state), {}, {
                  creditNotesBuyer: _this2.formSearch
                });
              });
              _this2.$EventBus.$emit("loading", true);
              _context.next = 5;
              return request("/v1/credit-notes/all", "post", _this2.formSearch, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load current credit notes.", {
                  type: "error"
                });
                _this.$EventBus.$emit("loading", false);
                throw e;
              });
            case 5:
              response = _context.sent;
              _this2.creditNoteCount = response.data.value.total_number;
              _this2.numberOfPages = Math.ceil(_this2.creditNoteCount / +_this2.formSearch.paging.limits);
              _this2.formSearch.paging.currentPage = _this2.formSearch.paging.askedPage + 1;
              _this2.items = response.data.value.items.map(function (x) {
                var _x$fromOrder, _x$fromOrder2;
                var item = _objectSpread(_objectSpread({}, x), {}, {
                  creationDate: x.creationDate && new Date(x.creationDate).toLocaleDateString("en-US"),
                  fromOrderInvoiceNumber: (_x$fromOrder = x.fromOrder) === null || _x$fromOrder === void 0 ? void 0 : _x$fromOrder.invoiceNumberLabel,
                  isLoadingFile: false,
                  isFromOrder: !!((_x$fromOrder2 = x.fromOrder) !== null && _x$fromOrder2 !== void 0 && _x$fromOrder2.id)
                });
                //_this.fetchCN(item)
                return item;
              });
              _this2.$EventBus.$emit("loading", false);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getCnFile: function getCnFile(item) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _item, response, fileImporter, file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              item.isLoadingFile = true;
              _item = item;
              _context2.next = 4;
              return request("/v1/credit-notes/".concat(item.id, "/files/cn"), "get", null, true, "api", null).catch(function (e) {
                _item.isLoadingFile = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load file");
                handleErrorData(_this, errorData);
                throw e;
              }).catch(function (_) {
                _item.isLoadingFile = false;
                throw e;
              });
            case 4:
              response = _context2.sent;
              fileImporter = response.data.value.find(function (x) {
                return !x.isCmFrIssuing;
              });
              file = fileImporter || response.data.value.find(function (x) {
                return x.isCmFrIssuing;
              });
              _context2.next = 9;
              return File.downloadFromUrl(file.url, file.filenameWithExt);
            case 9:
              item.isLoadingFile = false;
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    orderDetails: function orderDetails(orderId) {
      return {
        name: "userOrderSummary",
        params: {
          id: orderId
        }
      };
    },
    formatPrice: formatPrice,
    getSymbolCurrency: getSymbolCurrency
  }
};